import { Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import Card from 'components/Card';

export default function CardsExplorer(props) {
  const { cards, onCardSelected } = props;
  const missingCards = cards?.filter((row) => !row.collected);

  const collection = (
    missingCards?.map((row) => (
      <Grid xs={6} sm={4} md={3} key={row.id}>
        <Card
          {...row}
          onClick={() => onCardSelected(row)}
        />
      </Grid>
    ))
  );

  const noCardsMessage = (
    <Grid xs={12} container justifyContent="center" alignItems="center">
      <Grid>
        <Typography variant="h5" color="text.secondary">
          Nothing to see yet.
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
    >
      {cards?.length ? collection : noCardsMessage}
    </Grid>
  );
}
